import React from 'react';
import { FormSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useTalentNetworkSignupFilter } from './useTalentNetworkSignupFilter';

export const TalentNetworkSignupFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit, signupInfoOptions } = useTalentNetworkSignupFilter({
    setFilters,
  });

  return (
    <Formik
      initialValues={{ hasSignupInfo: value || signupInfoOptions[0] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="hasSignupInfo"
          label="Talent network signups"
          placeholder="Include"
          size="small"
          component={FormSelect}
          options={signupInfoOptions}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

TalentNetworkSignupFilter.propTypes = {
  value: PropTypes.object,
  setFilters: PropTypes.func.isRequired,
};

TalentNetworkSignupFilter.defaultProps = {
  value: null,
};
